// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-us-page .v-text-field__details .v-messages{color:var(--v-modalBackground-base)!important}", ""]);
// Exports
module.exports = exports;
